var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDetailsWithBackgroundCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FCF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 25V18M20.3333 15H20.3433M30.3333 20C30.3333 14.4772 25.8561 10 20.3333 10C14.8104 10 10.3333 14.4772 10.3333 20C10.3333 25.5228 14.8104 30 20.3333 30C25.8561 30 30.3333 25.5228 30.3333 20Z",
    stroke: "#8F27C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDetailsWithBackgroundCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/details-with-background-card-icon.a4d356594bcff0bd0b3c7d00462b324e.svg";